__webpack_require__.p = "https://static.spqr.app/76b2467d6648c084c41974c282306f3fba6eb549/_next/";